export default "__VITE_ASSET__8f262689__"